// Third-party Imports
import styled from '@emotion/styled'

// Type Imports
import type { VerticalNavProps } from '../../components/vertical-menu/VerticalNav'

type StyledVerticalNavBgColorContainerProps = Pick<VerticalNavProps, 'backgroundColor'>

const StyledVerticalNavBgColorContainer = styled.div<StyledVerticalNavBgColorContainerProps>`
  position: relative;
  block-size: 100%;
  z-index: 3;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(20px);
  border-inline-end: 1px solid rgba(140, 87, 255, 0.1);
  box-shadow: 0 0 40px rgba(140, 87, 255, 0.05);

  [data-theme='dark'] & {
    background-color: rgba(33, 30, 47, 0.75);
    border-inline-end: 1px solid rgba(140, 87, 255, 0.2);
    box-shadow: 0 0 40px rgba(140, 87, 255, 0.1);
  }

  ${({ backgroundColor }) => backgroundColor && `background-color:${backgroundColor};`}
`

export default StyledVerticalNavBgColorContainer
